export const ScreenType = {
  ALL_SCREEN: 0,
  SOICAL_WALL: 1,
  LEADER_BOARD: 2,
  ANALYTICS: 3,
  SOICAL_WALL_WITH_LEADER_BOARD: 4,
  SOICAL_WALL_WITH_ANALYTICS: 5,
};
export const ANIMATION_DURATION = 3000;
export const IS_AUTO_VIDEO_PLAY_ALLOWED = false;
export const ALL_CHANNEL = "ALL_CHANNEL";
export const dummyPostCard = [
  // only story
  {
    is_verified: false,
    author_id: "24077147941883656",
    tagid: 9711011,
    description: "",
    title: null,
    screen_name: "@official_mahi456z",
    channel_group_id: 3,
    author_name: "official_mahi456z",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-08 18:16:21",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "6602688479797569",
    tagid: 9711545,
    description: "",
    title: null,
    screen_name: "@tok1234o",
    channel_group_id: 3,
    author_name: "tok1234o",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 07:18:17",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "7206339046062120",
    tagid: 9711573,
    description: "",
    title: null,
    screen_name: "@aadi_3978",
    channel_group_id: 3,
    author_name: "aadi_3978",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 07:57:17",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "akashsoni07860",
    tagid: 9711512,
    description: "",
    title: null,
    screen_name: "@akashsoni07860",
    channel_group_id: 3,
    author_name: "akashsoni07860",
    attachments: [
      "https://s3.amazonaws.com/locobuzz.socialimages/InstagramMessage/bf5844f1-592f-4035-ab43-6b7e4e464315.jpg",
    ],
    likes_count: 0,
    comments_count: 0,
    retweets_count: 0,
    media_type: null,
    media_enum: 1,
    author_pic: "",
    CreatedDate: "2023-09-09 06:57:49",
    Engagement: 0,
    instagram_post_type: 11,
    rn: 1,
  },

  // {
  //   is_verified: false,
  //   author_id: "1698570057847328768",
  //   tagid: 9710965,
  //   description: "@King1868080 @aadesh1209 Ok bro",
  //   title: null,
  //   screen_name: "@ZinjadAdes75484",
  //   channel_group_id: 1,
  //   author_name: "Adesh Zinjad",
  //   attachments: [],
  //   likes_count: 1,
  //   comments_count: 0,
  //   retweets_count: 1,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1698570227779506176/znIwbYja_400x400.png",
  //   CreatedDate: "2023-09-08 17:15:30.297000",
  //   Engagement: 2,
  //   instagram_post_type: 1,
  //   rn: 1,
  // },
  // {
  //   is_verified: false,
  //   author_id: "1699764910933389312",
  //   tagid: 9710960,
  //   description: "Majak hai kya @aadesh1209",
  //   title: null,
  //   screen_name: "@King1868080",
  //   channel_group_id: 1,
  //   author_name: "King",
  //   attachments: [],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweets_count: 0,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1699764951907528704/T71lykgE_400x400.png",
  //   CreatedDate: "2023-09-08 17:10:40.063000",
  //   Engagement: 2,
  //   instagram_post_type: 1,
  //   rn: 1,
  // },
  // {
  //   is_verified: false,
  //   author_id: "1700222024566845440",
  //   tagid: 9711036,
  //   description: "Having fun @aadesh1209",
  //   title: null,
  //   screen_name: "@tester123762391",
  //   channel_group_id: 1,
  //   author_name: "tester123",
  //   attachments: [],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweets_count: 0,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png",
  //   CreatedDate: "2023-09-08 18:59:34.440000",
  //   Engagement: 0,
  //   instagram_post_type: 1,
  //   rn: 1,
  // },
  // {
  //   description: "@BittuLoco2030 generic alert",
  //   tag_id: 24019,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@loco55672477",
  //   post_url: null,
  //   author_name: "loco",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 Theek hai!!",
  //   tag_id: 24018,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@JunaidGehlot",
  //   post_url: null,
  //   author_name: "junaid Gehlot",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 Okay",
  //   tag_id: 24017,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@JunaidGehlot",
  //   post_url: null,
  //   author_name: "junaid Gehlot",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 hello u therte",
  //   tag_id: 24016,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@JunaidGehlot",
  //   post_url: null,
  //   author_name: "junaid Gehlot",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 hai there",
  //   tag_id: 24015,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@JunaidGehlot",
  //   post_url: null,
  //   author_name: "junaid Gehlot",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 Brisbane named host of the 2032 Olympic Games",
  //   tag_id: 24014,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@shubhan12605211",
  //   post_url: null,
  //   author_name: "shubhangini",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description:
  //     "@BittuLoco2030 People exchange greetings as Eid al-Adha is celebrated across the country",
  //   tag_id: 24013,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@JunaidGehlot",
  //   post_url: null,
  //   author_name: "junaid Gehlot",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description:
  //     "RT @Joe51893106: @BittuLoco2030 asidbasljdbailjsdbasj das dasbdui a8uhdoubdouizbfobfuo sbafoasbf8asdbiuobfo8u a sa fa sfuba sfbasoifnsoiu foadsjf oijasnfsd",
  //   tag_id: 24012,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@Gaurang32759829",
  //   post_url: null,
  //   author_name: "Gaurang TW test",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@Joe51893106 @BittuLoco2030 Test complaint",
  //   tag_id: 24011,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@shimulseo",
  //   post_url: null,
  //   author_name: "Shimul Aich",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
  // {
  //   description: "@BittuLoco2030 Hi",
  //   tag_id: 24010,
  //   channel_group_id: 1,
  //   title: null,
  //   screen_name: "@Mahmud84689048",
  //   post_url: null,
  //   author_name: "Mahmud",
  //   attachments: [
  //     "https://expertphotography.b-cdn.net/wp-content/uploads/2018/10/cool-profile-picture-natural-light.jpg",
  //   ],
  //   likes_count: 0,
  //   comments_count: 0,
  //   retweent_account: 0,
  // },
];
export const realTextPost = [
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: true,
    author_id: "1057240445812596736",
    tagid: 591859,
    description:
      "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge @friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge ",
    title: null,
    screen_name: "@Nishantchant",
    channel_group_id: 1,
    author_name: "Nishant 🇮🇳",
    attachments: [],
    likes_count: 194,
    comments_count: 0,
    retweets_count: 11,
    media_type: "",
    media_enum: 1,
    author_pic:
      "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
    created_date: "2023-09-05 08:22:01",
    engagement: 217,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
];
export const dummyTextImagePost = [
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  {
    is_verified: false,
    author_id: "117302418",
    tagid: 592814,
    description:
      "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6 I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
    title: null,
    screen_name: "@imra_mra",
    channel_group_id: 1,
    author_name: "Sandeep VS State",
    attachments: [
      {
        type: "image",
        link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
      },
    ],
    likes_count: 259,
    comments_count: 0,
    retweets_count: 79,
    media_type: "photo",
    media_enum: 2,
    author_pic:
      "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
    created_date: "2023-09-05 10:35:22",
    engagement: 374,
    instagram_post_type: 1,
    channel_type: 7,
    rn: 1,
  },
  // {
  //   is_verified: true,
  //   author_id: "96519866",
  //   tagid: 601525,
  //   description:
  //     "पीरियड के दौरान, लड़की ने @IndiGo6E फ्लाइट में पैड्स क्या मांग दिए... बवाल खड़ा हो गया....\n\nनफरती और बेशर्म पुरुषों के साथ-साथ महिलाएं भी लड़की को कोसने में पीछे नहीं रहीं.\n\nफ्लाइट के दरवाजे से टकराने पर पुरुष के सिर से खून निकलने लगे तो वह एयरहोस्टेस से बैंडेज मांगेगा या नहीं ?… https://t.co/tKmuqv5W2X",
  //   title: null,
  //   screen_name: "@TweetAbhishekA",
  //   channel_group_id: 1,
  //   author_name: "Abhishek Anand Journalist 🇮🇳",
  //   attachments: [
  //     {
  //       type: "image",
  //       link: "https://s3.amazonaws.com/locobuzz.socialimages/1699424987373821992_1.jpg",
  //     },
  //   ],
  //   likes_count: 2461,
  //   comments_count: 0,
  //   retweets_count: 700,
  //   media_type: "photo",
  //   media_enum: 2,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1636478718162919427/CGUPfGIh_400x400.jpg",
  //   created_date: "2023-09-06 14:11:05",
  //   engagement: 3477,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: false,
  //   author_id: "839674756911726593",
  //   tagid: 586041,
  //   description:
  //     "I was travelling @IndiGo6E today while I unexpectedly got my period. With full confidence I told my mother, “flight me toh pad mil hi jayega” but to my surprise there were 0 arrangements for such situations.",
  //   title: null,
  //   screen_name: "@friendlyemhoe",
  //   channel_group_id: 1,
  //   author_name: "shot of espresso",
  //   attachments: [],
  //   likes_count: 1216,
  //   comments_count: 0,
  //   retweets_count: 69,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1494971458199580672/PfYZb0HA_400x400.jpg",
  //   created_date: "2023-09-04 10:16:04",
  //   engagement: 1494,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "76294950",
  //   tagid: 584228,
  //   description:
  //     "Thank you Capt. Rahul Chhikara, FO. Prashant Hirve, cabin crew Taruna, Phupsang, Vipransha and Roselyn for your love, warmth and appreciation during my flight 6E-5325 to Amritsar! 😍🙌✈️ @IndiGo6E https://t.co/NSCojn55NR",
  //   title: null,
  //   screen_name: "@AnupamPKher",
  //   channel_group_id: 1,
  //   author_name: "Anupam Kher",
  //   attachments: [
  //     {
  //       type: "video",
  //       link: "https://video.twimg.com/amplify_video/1698542379400146945/vid/720x1280/-TIEmKVKpWo8HoNb.mp4?tag=14",
  //       thumb_url:
  //         "https://s3.amazonaws.com/locobuzz.socialimages/570f129e-4ee7-4d9c-a431-8379535d6f43_1.jpg",
  //     },
  //   ],
  //   likes_count: 1196,
  //   comments_count: 0,
  //   retweets_count: 58,
  //   media_type: "video",
  //   media_enum: 3,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1690627083612061696/0LG5xloW_400x400.jpg",
  //   created_date: "2023-09-04 03:46:52",
  //   engagement: 1272,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "64355384",
  //   tagid: 596002,
  //   description:
  //     "Dear @IndiGo6E \n\nPl do life time ban for flying to such unruly #FokatClass passengers who cannot take care of personal hygiene and cannot purchase a pad costing Rs 5. https://t.co/ArREwfvmjK",
  //   title: null,
  //   screen_name: "@cskkanu",
  //   channel_group_id: 1,
  //   author_name: "Chetan",
  //   attachments: [
  //     {
  //       type: "image",
  //       link: "https://s3.amazonaws.com/locobuzz.socialimages/1699120820470284711_1.jpg",
  //     },
  //   ],
  //   likes_count: 541,
  //   comments_count: 0,
  //   retweets_count: 210,
  //   media_type: "photo",
  //   media_enum: 2,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1615770073851121667/c27eoc9n_400x400.jpg",
  //   created_date: "2023-09-05 18:02:26",
  //   engagement: 813,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "720165751475343360",
  //   tagid: 593019,
  //   description:
  //     "@friendlyemhoe @IndiGo6E Everyone else must be responsible, except women",
  //   title: null,
  //   screen_name: "@ArnazHathiram",
  //   channel_group_id: 1,
  //   author_name: "Arnaz Hathiram",
  //   attachments: [],
  //   likes_count: 382,
  //   comments_count: 0,
  //   retweets_count: 35,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1656886956314247169/r19ULoqT_400x400.jpg",
  //   created_date: "2023-09-05 11:06:26",
  //   engagement: 422,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: false,
  //   author_id: "117302418",
  //   tagid: 592814,
  //   description:
  //     "I was going frm Delhi 2 Chennai by @IndiGo6E  I suddenly noticed that I have not shaven, I asked Airhostess, then she said that she does not have a Rajor only toothbrush\n\n I met Harpal ji on the same flight, he himself shaved my beard & made My Day\n\nHows my Story?\n@friendlyemhoe https://t.co/nYKqaZHgc6",
  //   title: null,
  //   screen_name: "@imra_mra",
  //   channel_group_id: 1,
  //   author_name: "Sandeep VS State",
  //   attachments: [
  //     {
  //       type: "image",
  //       link: "https://s3.amazonaws.com/locobuzz.socialimages/1699008313546158137_1.jpg",
  //     },
  //   ],
  //   likes_count: 259,
  //   comments_count: 0,
  //   retweets_count: 79,
  //   media_type: "photo",
  //   media_enum: 2,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1559351104902959104/ieVbWfkQ_400x400.jpg",
  //   created_date: "2023-09-05 10:35:22",
  //   engagement: 374,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "841156177",
  //   tagid: 591178,
  //   description:
  //     "@friendlyemhoe @IndiGo6E I blame bramhincial patriarchal for this as well as the caste system we have",
  //   title: null,
  //   screen_name: "@ACID_CHEL",
  //   channel_group_id: 1,
  //   author_name: "ACID",
  //   attachments: [],
  //   likes_count: 287,
  //   comments_count: 0,
  //   retweets_count: 26,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1684223846445109250/LLfGxXvB_400x400.jpg",
  //   created_date: "2023-09-05 06:35:19",
  //   engagement: 323,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: false,
  //   author_id: "900789766769197057",
  //   tagid: 568997,
  //   description:
  //     "🚀🛰️ Space science outreach has reached 30,000 feet over sea level. Our team passed a note  to the crew of @IndiGo6E ✈️ 892 from Kolkata to Chennai and the crew joined us in spreading word of the @isro #AdityaL1 mission to explore the Sun ☀️ @asipoec @cessi_iiserkol @iiserkol https://t.co/KQBIYhn4uw",
  //   title: null,
  //   screen_name: "@ydnad0",
  //   channel_group_id: 1,
  //   author_name: "Dibyendu Nandi",
  //   attachments: [
  //     {
  //       type: "video",
  //       link: "https://video.twimg.com/ext_tw_video/1697602487426207744/pu/vid/848x480/oy0kXaIGZKecg1Dz.mp4?tag=12",
  //       thumb_url:
  //         "https://s3.amazonaws.com/locobuzz.socialimages/1697602545940832409_1.jpg",
  //     },
  //   ],
  //   likes_count: 195,
  //   comments_count: 0,
  //   retweets_count: 38,
  //   media_type: "video",
  //   media_enum: 3,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1420490581176844291/p9TEhg5v_400x400.jpg",
  //   created_date: "2023-09-01 13:29:21",
  //   engagement: 245,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "1160596127298678784",
  //   tagid: 591938,
  //   description:
  //     "@friendlyemhoe @IndiGo6E isn’t pad a basic thing you are supposed to carry w you always 😭 itna kya rona rote ho tum log choti choti baaton pe, be more responsible",
  //   title: null,
  //   screen_name: "@beyondankita",
  //   channel_group_id: 1,
  //   author_name: "Ankita",
  //   attachments: [],
  //   likes_count: 205,
  //   comments_count: 0,
  //   retweets_count: 9,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1655568228893204480/0YVaX7Ht_400x400.jpg",
  //   created_date: "2023-09-05 08:35:17",
  //   engagement: 225,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
  // {
  //   is_verified: true,
  //   author_id: "1057240445812596736",
  //   tagid: 591859,
  //   description:
  //     "@friendlyemhoe @IndiGo6E Kal se asthma ka pump , blood pressure ki medicine , pad , lipstick condom , hot water , milk , sab rakhenge",
  //   title: null,
  //   screen_name: "@Nishantchant",
  //   channel_group_id: 1,
  //   author_name: "Nishant 🇮🇳",
  //   attachments: [],
  //   likes_count: 194,
  //   comments_count: 0,
  //   retweets_count: 11,
  //   media_type: "",
  //   media_enum: 1,
  //   author_pic:
  //     "https://pbs.twimg.com/profile_images/1691377475648208896/YWPrHKkp_400x400.jpg",
  //   created_date: "2023-09-05 08:22:01",
  //   engagement: 217,
  //   instagram_post_type: 1,
  //   channel_type: 7,
  //   rn: 1,
  // },
];
export const dummyAnalyticsData = {
  kpi_data: {
    widget_id: "afcdbbf9-80ab-4575-842a-d50e78e9d9ba",
    widget_name: "KPI CHART TYPE",
    widget_description: null,
    graph_type: "kpi",
    type: "widget-maker",
    filters: [],
    start_date: null,
    end_date: null,
    brand_ids: null,
    brand_groups: null,
    is_locked: false,
    span: "full",
    original_widget_id: "04468cec-7915-44c7-b29a-889469b41934",
    is_imported: true,
    chart: {
      chart_type: "kpi",
      chart_settings: {
        duration_comparison: true,
        duplicate_for_brands: false,
        show_data_labels: false,
        show_count_cards: true,
        is_stacked: true,
        total_row: null,
        show_marker: true,
        split_cards: false,
        card_percent: true,
        card_position: "Top",
        chart_percent: false,
        benchmark_line: null,
        group_line_agg: null,
        gradient_color: false,
        chart_property: {
          chart_name: "KPI CHART TYPE",
          legend_position: "bottom",
          y_axis_mode: 2,
        },
        y_axes_settings: [
          {
            show_as: "bar",
            y_axis_scale: "linear",
            color_pattern_code: 1,
            y_axis_map_at: 0,
          },
          {
            show_as: "line",
            y_axis_scale: "linear",
            color_pattern_code: 1,
            y_axis_map_at: 1,
          },
        ],
        cards_settings: [
          {
            x_axis: {
              attribute: "SentimentType",
              aggregation: null,
              date_part: null,
              frequency: null,
              sort_order: "desc",
              x_limit: 20,
              trace_name: "Sentiment With Mention Count",
            },
            y_series: {
              attribute: "tagid",
              alias: null,
              aggregation: "COUNT",
              trace_name: null,
              percent: false,
              filters: null,
            },
            sort_order: null,
            limit: null,
          },
        ],
        x_label: null,
        y_label: null,
      },
    },
    x_axis: {
      attribute: "UserLocation",
      aggregation: null,
      date_part: null,
      frequency: null,
      sort_order: "desc",
      x_limit: 10,
      trace_name: "User Location",
    },
    y_axes: null,
    y_series: [
      {
        attribute: "tagid",
        alias: null,
        aggregation: "COUNT",
        trace_name: "Mention Count",
        percent: false,
        filters: null,
      },
    ],
    profile_filters: null,
    widget_description_on_icon: false,
    order_by: null,
    exclude_words: null,
    comp_exclude_words: null,
    graphData: {
      data: {
        kpi: [
          {
            text: "Neutral",
            value: 363,
            color: "#deaa0c",
            percent_change: -8.8,
            share: 69.67,
            attribute: "SentimentType",
          },
          {
            text: "Positive",
            value: 114,
            color: "#1c9f00",
            percent_change: -42.1,
            share: 21.88,
            attribute: "SentimentType",
          },
          {
            text: "Negative",
            value: 44,
            color: "#dc1e1e",
            percent_change: 10,
            share: 8.45,
            attribute: "SentimentType",
          },
          {
            text: "India",
            value: 75,
            color: "#000000",
            percent_change: -33,
            share: 67.57,
            attribute: "UserLocation",
          },
          {
            text: "Mumbai",
            value: 13,
            color: "#000000",
            percent_change: 18.2,
            share: 11.71,
            attribute: "UserLocation",
          },
          {
            text: "Gurugram",
            value: 6,
            color: "#000000",
            percent_change: null,
            share: 5.41,
            attribute: "UserLocation",
          },
          {
            text: "Gurgaon",
            value: 6,
            color: "#000000",
            percent_change: -14.3,
            share: 5.41,
            attribute: "UserLocation",
          },
          {
            text: "Navi Mumbai",
            value: 4,
            color: "#000000",
            percent_change: null,
            share: 3.6,
            attribute: "UserLocation",
          },
          {
            text: "India , Mumbai",
            value: 3,
            color: "#000000",
            percent_change: 200,
            share: 2.7,
            attribute: "UserLocation",
          },
          {
            text: "Mumbai, Maharashtra",
            value: 1,
            color: "#000000",
            percent_change: -85.7,
            share: 0.9,
            attribute: "UserLocation",
          },
          {
            text: "Haldwani",
            value: 1,
            color: "#000000",
            percent_change: null,
            share: 0.9,
            attribute: "UserLocation",
          },
          {
            text: "Greater Noida, India",
            value: 1,
            color: "#000000",
            percent_change: null,
            share: 0.9,
            attribute: "UserLocation",
          },
          {
            text: "Greater Noida",
            value: 1,
            color: "#000000",
            percent_change: null,
            share: 0.9,
            attribute: "UserLocation",
          },
        ],
      },
      refresh_ri: false,
    },
    insights: null,
    note: "",
  },
  line_chart_data: {
    widget_id: "a2bc838c-4545-4e0e-b280-c58caa3e3dea",
    widget_name: "LINE CHART",
    widget_description: null,
    graph_type: "line",
    type: "widget-maker",
    filters: [],
    start_date: null,
    end_date: null,
    brand_ids: null,
    brand_groups: null,
    is_locked: false,
    span: "full",
    original_widget_id: "4ff08d31-016f-485c-9896-6b83ae6f7bc5",
    is_imported: true,
    chart: {
      chart_type: "line",
      chart_settings: {
        duration_comparison: false,
        duplicate_for_brands: false,
        show_data_labels: false,
        show_count_cards: true,
        is_stacked: true,
        chart_percent: false,
        gradient_color: false,
        chart_property: {
          chart_name: "LINE CHART",
          legend_position: "bottom",
          y_axis_mode: 2,
          no_of_top_posts: 1,
        },
        show_previous_duration_comparison: false,
        show_previous_duration_data: false,
        total_row: false,
        show_marker: true,
        split_cards: true,
        card_limit: 5,
        card_percent: true,
        card_position: "Top",
        top_posts_in_cards: false,
        benchmark_line: null,
        group_line_agg: null,
        y_axes_settings: [
          {
            show_as: "bar",
            y_axis_scale: "linear",
            color_pattern_code: 1,
            y_axis_map_at: 0,
          },
        ],
        cards_settings: [],
        x_label: null,
        y_label: null,
      },
    },
    x_axis: {
      attribute: "CreatedDate",
      aggregation: null,
      date_part: "8h",
      frequency: null,
      sort_order: "asc",
      x_limit: 30,
      trace_name: "Hour of Day",
    },
    y_axes: null,
    y_series: [
      {
        attribute: "tagid",
        alias: null,
        aggregation: "COUNT",
        trace_name: "Mention Count",
        percent: false,
        filters: null,
      },
    ],
    profile_filters: null,
    widget_description_on_icon: false,
    order_by: null,
    exclude_words: null,
    comp_exclude_words: null,
    graphData: {
      data: {
        kpi: [],
        line: [
          {
            data: [
              {
                x: [
                  "2023-08-27 00:00:00",
                  "2023-08-27 08:00:00",
                  "2023-08-27 16:00:00",
                  "2023-08-28 00:00:00",
                  "2023-08-28 08:00:00",
                  "2023-08-28 16:00:00",
                  "2023-08-29 00:00:00",
                  "2023-08-29 08:00:00",
                  "2023-08-29 16:00:00",
                  "2023-08-30 00:00:00",
                  "2023-08-30 08:00:00",
                  "2023-08-30 16:00:00",
                  "2023-08-31 00:00:00",
                  "2023-08-31 08:00:00",
                  "2023-08-31 16:00:00",
                  "2023-09-01 00:00:00",
                  "2023-09-01 08:00:00",
                  "2023-09-01 16:00:00",
                ],
                y: [
                  5, 5, 1, 1, 51, 45, 1, 70, 32, 9, 59, 45, 4, 28, 58, 4, 85,
                  18,
                ],
                color: "#000000",
              },
            ],
            bar_type: false,
            stacked: false,
            log: false,
            trace_name: "",
            min: 0,
            max: 85,
          },
        ],
      },
      refresh_ri: false,
    },
    insights: null,
    note: "",
  },
  wordcloud_data: {
    widget_id: "d6d6043e-9982-4afe-920a-37d0980ed0b9",
    widget_name: "keyword wordcloud",
    widget_description: null,
    graph_type: "wordcloud",
    type: "widget-maker",
    filters: [],
    start_date: null,
    end_date: null,
    brand_ids: null,
    brand_groups: null,
    is_locked: false,
    span: "full",
    original_widget_id: "99cfa015-7ce1-4b3c-b909-dfd490bc9deb",
    is_imported: true,
    chart: {
      chart_type: "wordcloud",
      chart_settings: {
        duration_comparison: false,
        duplicate_for_brands: true,
        show_data_labels: false,
        show_count_cards: true,
        is_stacked: true,
        total_row: false,
        show_marker: true,
        card_percent: true,
        card_position: "Top",
        chart_percent: false,
        benchmark_line: null,
        group_line_agg: null,
        chart_property: {
          chart_name: "keyword wordcloud",
          legend_position: "bottom",
          y_axis_mode: 2,
        },
        y_axes_settings: [
          {
            show_as: "bar",
            y_axis_scale: "linear",
            color_pattern_code: 1,
            y_axis_map_at: 0,
          },
        ],
        cards_settings: [],
        x_label: null,
        y_label: null,
      },
    },
    x_axis: {
      attribute: "TagCloud",
      aggregation: null,
      date_part: null,
      frequency: null,
      sort_order: "desc",
      x_limit: 10,
      trace_name: "Keywords",
    },
    y_axes: null,
    y_series: [
      {
        attribute: "tagid",
        alias: null,
        aggregation: "COUNT",
        trace_name: "Mention Count",
        percent: false,
        filters: null,
      },
    ],
    profile_filters: null,
    widget_description_on_icon: false,
    order_by: null,
    exclude_words: null,
    comp_exclude_words: null,
    graphData: {
      wordcloud: [
        {
          data: [
            {
              text: "clicking",
              value: 78,
              percent: 17.14,
              color: "#000000",
            },
            {
              text: "helped",
              value: 67,
              percent: 14.73,
              color: "#000000",
            },
            {
              text: "delighted",
              value: 67,
              percent: 14.73,
              color: "#000000",
            },
            {
              text: "customer",
              value: 39,
              percent: 8.57,
              color: "#000000",
            },
            {
              text: "tata",
              value: 35,
              percent: 7.69,
              color: "#000000",
            },
            {
              text: "interaction",
              value: 35,
              percent: 7.69,
              color: "#000000",
            },
            {
              text: "cliq",
              value: 35,
              percent: 7.69,
              color: "#000000",
            },
            {
              text: "2023",
              value: 34,
              percent: 7.47,
              color: "#000000",
            },
            {
              text: "comment",
              value: 34,
              percent: 7.47,
              color: "#000000",
            },
            {
              text: "issue",
              value: 31,
              percent: 6.81,
              color: "#000000",
            },
          ],
          bar_type: false,
          stacked: false,
          log: false,
          trace_name: "",
          min: -1,
          max: -1,
        },
      ],
    },
    insights: null,
    note: "",
  },
  sunburst_data: {
    widget_id: "720cda9c-e029-415e-8396-b6fceaa22a71",
    widget_name: "sunburst ",
    widget_description: null,
    graph_type: "sunburst",
    type: "widget-maker",
    filters: [],
    start_date: null,
    end_date: null,
    brand_ids: null,
    brand_groups: null,
    is_locked: false,
    span: "full",
    original_widget_id: "e9228221-6fdf-4120-8431-e8e93511052c",
    is_imported: true,
    chart: {
      chart_type: "sunburst",
      chart_settings: {
        duration_comparison: false,
        duplicate_for_brands: true,
        show_data_labels: false,
        show_count_cards: true,
        is_stacked: true,
        total_row: true,
        show_marker: true,
        card_percent: true,
        card_position: "Top",
        chart_percent: false,
        benchmark_line: null,
        group_line_agg: null,
        chart_property: {
          chart_name: "sunburst ",
          legend_position: "bottom",
          y_axis_mode: 2,
        },
        y_axes_settings: [
          {
            show_as: "bar",
            y_axis_scale: "linear",
            color_pattern_code: 1,
          },
        ],
        cards_settings: [],
        x_label: null,
        y_label: null,
      },
    },
    x_axis: {
      attribute: "ChannelType",
      aggregation: null,
      date_part: null,
      frequency: null,
      sort_order: "desc",
      x_limit: 10,
      trace_name: "Inner Channel",
    },
    y_axes: [
      {
        chart_type: null,
        attribute: "SocialMediaPlatforms",
        trace_name: "Channel",
        aggregation: null,
        date_part: null,
        frequency: null,
        sort_order: "desc",
        y_limit: 5,
        is_pivot: false,
      },
    ],
    y_series: [
      {
        attribute: "tagid",
        alias: null,
        aggregation: "COUNT",
        trace_name: "Mention Count",
        percent: false,
        filters: null,
      },
    ],
    profile_filters: null,
    widget_description_on_icon: false,
    order_by: null,
    exclude_words: null,
    comp_exclude_words: null,
    graphData: {
      sunburst: [
        {
          data: [
            {
              id: "0.0",
              parent: "",
              name: "Inner Channel",
            },
            {
              id: "0.1",
              parent: "0.0",
              name: 80,
              color: "#000000",
            },
            {
              id: "1.1",
              parent: "0.1",
              name: "GBM",
              value: 28,
              color: "#CE30F4",
            },
            {
              id: "0.2",
              parent: "0.0",
              name: "Brand Tweets",
              color: "#000000",
            },
            {
              id: "2.2",
              parent: "0.2",
              name: "Twitter",
              value: 19,
              color: "#19bfe5",
            },
            {
              id: "0.3",
              parent: "0.0",
              name: "Complaint Websites",
              color: "#000000",
            },
            {
              id: "3.3",
              parent: "0.3",
              name: "Complaint Websites",
              value: 18,
              color: "#185edf",
            },
            {
              id: "0.4",
              parent: "0.0",
              name: "FB Comments",
              color: "#000000",
            },
            {
              id: "4.4",
              parent: "0.4",
              name: "Facebook",
              value: 90,
              color: "#1877f2",
            },
            {
              id: "0.5",
              parent: "0.0",
              name: "FB Page User",
              color: "#000000",
            },
            {
              id: "5.5",
              parent: "0.5",
              name: "Facebook",
              value: 102,
              color: "#1877f2",
            },
            {
              id: "0.6",
              parent: "0.0",
              name: "Instagram Comments",
              color: "#000000",
            },
            {
              id: "6.6",
              parent: "0.6",
              name: "Instagram",
              value: 25,
              color: "#f00075",
            },
            {
              id: "0.7",
              parent: "0.0",
              name: "Instagram Page Posts",
              color: "#000000",
            },
            {
              id: "7.7",
              parent: "0.7",
              name: "Instagram",
              value: 26,
              color: "#f00075",
            },
            {
              id: "0.8",
              parent: "0.0",
              name: "Public Tweets",
              color: "#000000",
            },
            {
              id: "8.8",
              parent: "0.8",
              name: "Twitter",
              value: 130,
              color: "#19bfe5",
            },
            {
              id: "0.9",
              parent: "0.0",
              name: "Twitter brand mention",
              color: "#000000",
            },
            {
              id: "9.9",
              parent: "0.9",
              name: "Twitter",
              value: 48,
              color: "#19bfe5",
            },
          ],
          bar_type: true,
          stacked: true,
          log: false,
          trace_name: "Inner Channel",
          min: -1,
          max: -1,
        },
      ],

      refresh_ri: false,
    },
    insights: null,
    note: "",
  },
  map_data: {
    widget_id: "4eef4956-a317-4f9c-a4a6-f07b6cd2d88b",
    widget_name: "Map Tested",
    widget_description: null,
    graph_type: "map",
    type: "widget-maker",
    filters: [],
    start_date: null,
    end_date: null,
    brand_ids: null,
    brand_groups: null,
    is_locked: false,
    span: "full",
    original_widget_id: "e4522bb6-972b-42c7-b263-722f805bd536",
    is_imported: true,
    chart: {
      chart_type: "map",
      chart_settings: {
        duration_comparison: false,
        duplicate_for_brands: false,
        show_data_labels: false,
        show_count_cards: true,
        is_stacked: true,
        total_row: false,
        show_marker: true,
        card_percent: true,
        card_position: "Top",
        chart_percent: false,
        benchmark_line: null,
        group_line_agg: null,
        chart_property: {
          chart_name: "Map Tested",
          legend_position: "bottom",
          y_axis_mode: 2,
        },
        y_axes_settings: [],
        cards_settings: [],
        x_label: null,
        y_label: null,
      },
    },
    x_axis: null,
    y_axes: null,
    y_series: [
      {
        attribute: "NumLikesCount",
        alias: null,
        aggregation: "SUM",
        trace_name: "Post Likes",
        percent: false,
        filters: null,
      },
    ],
    profile_filters: null,
    widget_description_on_icon: false,
    order_by: null,
    exclude_words: null,
    comp_exclude_words: null,
    graphData: {
      data: {
        kpi: [],
        map: [
          {
            data: [
              {
                latitude: [
                  0, 19.07283, 19.03681, 23.18239, 20, 28.4601, 28.49615,
                  29.22254,
                ],
                longitude: [
                  0, 72.88261, 73.01582, 75.77643, 77, 77.02635, 77.53601,
                  79.5286,
                ],
                count: [
                  0, 72.88261, 73.01582, 75.77643, 77, 77.02635, 77.53601,
                  79.5286,
                ],
              },
            ],
            bar_type: true,
            stacked: false,
            log: false,
            trace_name: "",
            min: -1,
            max: -1,
          },
        ],
      },
      refresh_ri: false,
    },
    insights: null,
    note: "",
  },
};
